<template>
  <div class="content if-profile px-4">
    <div class="md-layout if-profile-body">
      <div v-if="this.$route.name != 'Register'" class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <nav aria-label="breadcrumb" role="navigation">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: defaultScreen }"> Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'Privacy' }">
                Web Site Terms of Service
              </router-link>
            </li>
          </ol>
        </nav>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <!-- <div class="md-layout page-wrapper">
          <div class="md-layout-item privacy-policy md-size-100">
            <h1 class="md-display-3">Web Site Terms of Service</h1>
          </div>
        </div> -->
        <h1 class="section_header">Web Site Terms of Service</h1>
        <h4 class="md-headline m-0" :class="this.$route.name != 'Register'?'':'tos-text-register'">
          BY USING THIS SITE YOU AGREE TO THE TERMS BELOW:
        </h4>
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
            <md-card class="if_card">
              <md-card-header>
                Use of Content
              </md-card-header>
              <md-card-content>
                <div class="extra_space">
                  <!-- <h5 class="md-headline">
                    BY USING THIS SITE YOU AGREE TO THE TERMS BELOW:
                  </h5> -->
                  <!-- <span class="md-title">Use of Content</span> -->
                  <p>
                    Bizminer grants a non-exclusive limited license to the Purchaser
                    (you or the business entity purchasing the report) or (in the case
                    of a a license accessing individual or entity) to use the data,
                    whether transmitted electronically, on CD-ROM, diskette or hard
                    copy, or on discs, under the terms and conditions set forth below:
                  </p>
                  <p>
                    You may use a purchased one-off report for internal personal or
                    business purposes. You may use a licensed report for purposes
                    detail below. You may also use Bizminer content as a value added
                    portion of a significantly larger engagement with a single
                    third-party end user, but not to publish or otherwise distribute
                    the Profile or the information in it. You may integrate the report
                    or its content into a single valuation, business plan appraisal or
                    other document intended for use with a single bona fide client.
                  </p>
                  <p>
                    This license does not extend to distributing or reselling the
                    report or information in any report to multiple entities without
                    the express written permission of Bizminer. No other print copies
                    or electronic copies are permitted.
                  </p>
                </div>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
            <md-card class="if_card">
              <md-card-header>
                Refund Policy
              </md-card-header>
              <md-card-content>
                <div class="extra_space">
                  <!-- <span class="md-title">Refund Policy</span> -->
                  <p>
                    If you have questions about the content of any report series, we
                    urge you review the free samples provided throughout the selection
                    process or at
                    <router-link to="/ui-elements/typography">www.bizminer.com/products/</router-link>
                    or contact us by phone or email before making a purchase. We do
                    not extend refunds or credits for purchases, including
                    subscriptions.
                  </p>
                  <p>
                    We provide clearly accessible free samples of each Bizminer report
                    series on our site. The samples are for a generic industry, but
                    the metrics and measures displayed for each report series are
                    identical to those displayed in every report within that series,
                    regardless of the industry or area selected. We do not provide
                    individual company lists or information in any report series
                    except where specifically stated in the free sample. Where there
                    is a reasonable question as to the accuracy of statistics we
                    present, we will make a reasonable effort to check the underlying
                    data and assure that we have reported or manipulated it
                    accurately.
                  </p>
                  <p>
                    When you purchase an online report, you will be taken to an
                    account page which has been established for you. You can access
                    your reports from that page by selecting the corresponding icons.
                    In addition, we will send you an email with login information for
                    unlimited future access to your reports. We will utilize the email
                    that you input prior to your transaction. It is your
                    responsibility to input a valid email address, and to set your
                    spam controls so that you can receive the information from us. If
                    you did not provide a valid email address, or were unable to
                    receive our email, we have still attempted to deliver both the
                    report and access information to you. Additionally, you can call
                    us (866-863-9853) or email us at any time if you have difficulty
                    accessing your reports online. Since our systems provide all the
                    information and assistance you need to access your reports within
                    a reasonable period of time, we will not provide refunds for
                    reports that you do not access with the information we send you or
                    with the follow-up assistance offered here.
                  </p>
                  <p>
                    Limitations: As is the case with any databases this large, some
                    errors are inevitable. Some firms are missed and specific
                    information on others is lacking from the database. Not all
                    information received is uniform or complete, resulting in the need
                    to develop projection algorithms for specific industry segments
                    and metrics in some report series. No representation is made as to
                    the accuracy of the databases utilized or the results of
                    subsequent analyses. Neither the Bizminer nor its resellers has
                    undertaken independent primary research to confirm the accuracy of
                    the data utilized in the Profile analyses. Neither the Bizminer
                    nor its resellers are responsible for conclusions drawn or
                    decisions made based upon this data or analysis. In no event will
                    the Bizminer or its resellers be liable for any damages, direct,
                    indirect, incidental or consequential resulting from the use of
                    the information contained in Bizminer reports.
                  </p>
                </div>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
            <md-card class="welcome-card-wrap if_card">
              <md-card-header>
                LICENSE TERMS OF SERVICE AND USE
              </md-card-header>
              <md-card-content>
                <div class="extra_space">
                  <!-- <span class="md-title">LICENSE TERMS OF SERVICE AND USE</span> -->
                  <h6 class="md-subheading">
                    Bizminer Commercial License Agreement and Terms of Service
                  </h6>
                  <p>
                    Bizminer offers Commercial Licenses to businesses and individuals
                    who plan to use Bizminer data in-house or in conjunction with
                    value-added reports or projects for clients. Depending on your
                    purchase, the Commercial License includes access to one or more of
                    these Bizminer database licenses (Licensed Content) during the
                    license period, subject to the use limitations of this Agreement:
                  </p>
                  <ul>
                    <li>US Industry Financial License</li>
                    <li>Local Industry Financial License</li>
                    <li>Industry Market License</li>
                    <li>Valuation Toolkit</li>
                    <li>Bizminer Suite</li>
                    <li>Bizminer Gold Suite</li>
                    <li>Valuation Multiples</li>
                    <li>Business Prospect Lists and Company Insights</li>
                  </ul>
                  <p>
                    Bizminer Commercial License pricing is based on the number of
                    Users in your organization who will be accessing, analyzing,
                    utilizing or viewing Licensed Content in direct or indirect
                    formats, either in-house or with bona fide third-party end user
                    clients as described below. Fourth-party end use is prohibited,
                  </p>
                  <p>
                    both inside and outside of your organization. This means that if a
                    licensed user shares licensed content with another unlicensed
                    person inside the organization, that content can go no further;
                    for example, at that point it cannot be used, without an outside,
                    fourth-party client viewer.
                  </p>
                  <p>
                    Each person in your organization who accesses, analyzes or
                    utilizes Licensed Content is required to have a paid, authorized
                    subscription. Contract employees are not authorized to access,
                    analyze, utilize or view Licensed Content without special written
                    permission of Bizminer. However, administrative personnel of your
                    organization may access content for a professional of the
                    licensing organization without being counted as user if they are
                    not engaged in any review or analysis of Licensed Content.
                  </p>
                  <p>
                    Authorized users may access licensed content from no more than
                    three devices. The concurrent use of multiple devices in a single
                    user account is prohibited. Bizminer maintains the right to
                    monitor device usage under this license: authorized users may be
                    notified and required to electronically certify a change in
                    authorized devices if a login attempt is made through an
                    unauthorized device. Distribution of login data or Licensed
                    Content to non-authorized persons or entities is prohibited and
                    may be cause for the revocation of this license without refund at
                    Bizminer’s sole discretion.
                  </p>
                  <p>
                    The Single User Commercial License fee secures the right of a
                    single authorized user to access a limited number of reports
                    within the License period as follows:
                  </p>
                  <ul>
                    <li>
                      US Industry Financial License: up to 75 reports (12 month
                      subscription); 35 reports (6 month subscription)
                    </li>
                    <li>
                      Local Industry Financial License: up to 75 reports (12 month
                      subscription); 35 reports (6 month subscription)
                    </li>
                    <li>
                      Industry Market License: up to 75 reports (12 month
                      subscription); 35 reports (6 month subscription
                    </li>
                    <li>
                      Valuation Toolkit: up to 75 reports and 300 searches (12 month
                      subscription); 30 reports and 125 searches (6 month
                      subscription)
                    </li>
                    <li>
                      Suite Access: up to 150 reports (12 month subscription); 75
                      reports (6 month subscription)
                    </li>
                    <li>
                      Gold Suite Access: up to 200 reports (12 month subscription);
                      100 reports (6 month subscription)
                    </li>
                    <li>
                      Valuation Multiples: up to 150 searches (12 month subscription
                      for single size brackets); up to 300 searches (12 month
                      subscription for the all four size bracket option)
                    </li>
                    <li>
                      Business Prospect Lists and Company Insights: as priced at sale,
                      credits valid for 12 months
                    </li>
                  </ul>
                  <p>
                    Bizminer recommends discussion of questions about limitations on
                    access and use of Licensed Content prior to purchase, and may be
                    contacted at 866-863-9853 during business hours (Eastern Time) or
                    by email at
                    <router-link to="/ui-elements/typography">http://www.bizminer.com/contact.php.</router-link>
                  </p>
                  <br />
                  <h6 class="md-subheading">
                    Bizminer Commercial License Agreement and Terms of Service
                  </h6>
                  <p>
                    The Commercial License is valid for in-house use by licensed
                    individuals subject to the limitations on use detailed below. No
                    other persons in the licensing organization or its contractors may
                    access, analyze, utilize or review Licensed Content. Subject to
                    the restrictions in the Limitations on Use section, licensed
                    subscribers are permitted to utilize the content with bona fide
                    third party end-user clients as part of significantly value-added
                    reports or projects. For example, content may be included as part
                    of a custom business plan, a custom valuation report individually
                    developed and integrated by professional licensees for bona fide
                    end user clients, or as part of a personalized financial review
                    with counseling <br />
                    <br />
                    conducted by an accountant or consultant. The number of clients or
                    client entities to which permitted uses apply is not limited.
                  </p>
                  <br />
                  <h6 class="md-subheading">
                    Access to Licensed Content is subject to the following
                    restrictions:
                  </h6>
                  <ul>
                    <li>
                      No more than nine Licensed Content reports or data from nine
                      Licensed Content reports may be shared with any one client or
                      client entity.)
                    </li>
                    <li>
                      The creation of files or databases which aggregate Licensed
                      Content for in-house use is limited to part or all of 25
                      Licensed Content reports.
                    </li>
                    <li>
                      Content can NOT be harvested for integration into either
                      Subscriber or third-party end user databases. "Harvested"
                      content includes data which is loaded without a current due
                      diligence need or immediate, active client engagement.
                    </li>
                    <li>
                      Use or integration of Licensed Content in any electronic
                      database or engine for either front end or back-end use with
                      third party clients, or for any online use or integration,
                      displayed or otherwise, is strictly prohibited unless such use
                      or display is confined to authorized Users.
                    </li>
                    <li>
                      Distribution of any Licensed Content beyond bona fide third
                      party end-user clients as described above is prohibited,
                      including distribution at educational, marketing or other
                      quasi-public or by-invitation public events; any electronic or
                      other posting on a web site or in any other electronic format
                      aside from bona fide end user clients as detailed above;
                      distribution of Licensed Content reports or data in whole or
                      part without the addition of significant value-added materials
                      or delivery of significant value-added services in addition to
                      the licensed report or content. Otherwise, data re-sale or
                      re-engineering, web or electronic-based commerce or distribution
                      or re-sale to anyone outside your organization is not permitted.
                    </li>
                    <li>
                      To the extent that licensed content includes dynamic mapping,
                      the map on each report may limit the number of dynamic loads,
                      after which map views will become static. All metrics will
                      remain available during the report storage period, but the
                      licensee will not be able to navigate around map views or create
                      in-map data bubbles after the fifth dynamic map load. After the
                      first map load, Bizminer will provide alternative means to view
                      data (PDF and/or CSV files) and create inputs (from a link on
                      the report storage page) without the need to incur additional
                      dynamic map loads.
                    </li>
                    <li>
                      Valuation Multiples: up to 150 searches (12 month subscription
                      for single size brackets); up to 300 searches (12 month
                      subscription for the all four size bracket option)
                    </li>
                  </ul>
                  <br />
                  <h6 class="md-subheading">Data Integrity: Reports and Lists</h6>
                  <p>
                    As is the case with any databases this large, some errors are
                    inevitable. Some firms are missed and specific information on
                    others is lacking from the database. Not all information received
                    is uniform or complete, resulting in the need to develop
                    projection algorithms for specific industry segments and metrics
                    in some report series. No representation is made as to the
                    accuracy of the databases utilized or the results of subsequent
                    analyses. Licensor has not undertaken independent primary research
                    to confirm the accuracy of the data utilized in the analyses.
                    Licensor is not responsible for conclusions drawn or decisions
                    made based upon this data or analysis. Content should not be
                    utilized for the purposes of business or financial
                    decision-making. In no event will Licensor be liable for any
                    damages, direct, indirect, incidental or consequential resulting
                    from the use of the information contained in the reports.<br />
                    <br />
                    Where there is a reasonable question as to the accuracy of
                    statistics presented data, Bizminer will make a reasonable effort
                    to check the underlying data and assure that it has been reported
                    or manipulated accurately. Licensor will make a good faith and
                    reasonable effort to provide purchased list business contact
                    information as received from raw business record providers and
                    other sources, but in no event will Licensor be responsible for
                    any errors or omissions in any such Lists, which inevitably
                    contain an industry standard percentage of error.
                  </p>
                  <br />
                  <h6 class="md-subheading">
                    Access to Reports and Optional Business Lists
                  </h6>
                  <p>
                    Reports will be stored on the web site for 30 days after each
                    report or list is selected. Licensee can login, access and
                    download the Report and List as often as desired during that time.
                    Licensee is strongly encouraged to download and save all Report
                    and List content, which will be removed from the Licensee
                    Authorized Users' My Reports page after 30 days.
                  </p>
                  <br />
                  <h6 class="md-subheading">Termination and Cancellation</h6>
                  <p>
                    Subscriptions cannot be cancelled or revised once purchased,
                    except at Licensor's sole discretion. Bizminer reserves the right
                    to cancel your subscription at any time and refund your cost. No
                    refund will be due if these Terms are breached by you or a user
                    acting on your behalf. <br />
                    <br />
                    If your subscription expires, access to your account will be
                    blocked. If you renew within 30 days of the expiration of a
                    one-year subscription, or within 15 days of the expiration of a
                    six-month subscription, and require access to already-loaded
                    reports, your new subscription dates will be calculated from the
                    end of your prior expiration date. If you do not renew within the
                    specified periods for one-year or six month subscriptions, access
                    will be permanently blocked and stored reports will be deleted
                    from our system.
                  </p>
                  <br />
                  <h6 class="md-subheading">Breach of License</h6>
                  <p>
                    Misrepresentation of use of the Content or of the number of
                    persons related to Licensee entity who will be accessing or
                    utilizing Licensed Content constitutes a breach of the Terms of
                    Service and may result in cancellation by Licensor without refund
                    or credit as well as and recovery of damages by Licensor. Engaging
                    in prohibited use or distribution of Licensed Content, constitutes
                    a breach of the Terms of Service and will result in cancellation
                    without refund or credit as well as recovery of by Licensor for
                    damages caused by such prohibited use. <br />
                    <br />
                    Licensee agrees that there are no other refunds on Bizminer
                    reports or subscriptions. Fees are non-refundable whether or not
                    reports are accessed during your Subscription period.
                  </p>
                  <h6 class="md-subheading">Warranties/Limitations</h6>
                  <p>
                    Content provided by the Licensor is offered on an "as is", "as
                    available" basis. Licensor warrants that it has the right to
                    license the rights granted under this License to use the Licensed
                    Materials. Licensor does not warrant the accuracy, completeness,
                    timeliness of content, merchantability or fitness for a particular
                    purpose of the information available through the IMR or Lists.
                    Licensor shall not be liable to the Licensee or any Authorized
                    User or anyone else for any loss or injury caused in whole or part
                    by its negligence or compilation, interpretation, reporting or
                    delivering the IMR or Lists or information contained in them. In
                    no event will Licensor be liable to the Licensee or any Authorized
                    User or anyone else for any decision <br />
                    <br />
                    made or action taken by the Licensee or any Authorized User or
                    anyone else in reliance on information contained in the Reports,
                    or for direct, consequential, special or similar damages, even if
                    advised of the possibility of such damages. The Licensee agrees
                    that the liability of Licensor, if any, arising out of any kind of
                    legal claim (whether in contract, tort, negligence or otherwise),
                    in any connected with the service or the information in the
                    service, shall not exceed the amount the licensee paid to Licensor
                    for use of the License.
                  </p>
                  <br />
                  <h6 class="md-subheading">General</h6>
                  <p>
                    This Agreement contains the final and entire agreement between
                    Licensor and Licensee and supersedes other verbal or written
                    negotiations, understandings or agreements, until such time as
                    modifications or amendments to the Agreement are mutually agreed
                    to in writing and signed by the authorized representatives of both
                    parties. The terms and conditions outlined in this Agreement
                    override all online "click-through" agreements, any "click-wrap"
                    agreements, any automatic update agreements, and any other
                    agreement, of whatever kind, whereby users of the Software purport
                    to enter into or accept contractual terms or conditions that are
                    different from, or in addition to, this Agreement. Both parties'
                    rights and obligations of this Agreement are not assignable
                    without prior written consent of the other party, which consent
                    cannot be unreasonably withheld. <br />
                    <br />
                    This Agreement is enforceable only against and by the parties who
                    have executed it; the Agreement neither creates nor restricts
                    rights in third parties. Further, if any provision of the
                    Agreement provides that Licensee shall enforce the terms of this
                    Agreement against third parties, or restricts the legal rights of
                    third parties, such provision shall be void. <br />
                    <br />
                    If any provision of this Agreement is invalid under applicable
                    law, the remaining provisions will continue in full force and
                    effect. <br />
                    <br />
                    Security: You are responsible for maintaining the security of your
                    Subscriber username and password. You are responsible for activity
                    and charges incurred by any persons using your username and
                    password to log into your account. If you feel that your username
                    and password has been compromised, it is your responsibility to
                    change the username and password on your account immediately and
                    contact Bizminer regarding any perceived unauthorized use. <br />
                    <br />
                    Assignment and Venue: Your rights and obligations under this
                    Agreement are not assignable. If any provision of this Agreement
                    is invalid under applicable law, the remaining provisions will
                    continue in full force and effect. This Agreement will be governed
                    and construed in accordance with the laws of the Commonwealth of
                    Pennsylvania and any dispute arising out of this Agreement shall
                    be filed in a court of competent jurisdiction in Cumberland
                    County, Pennsylvania. The parties agree that Licensee, by agreeing
                    to venue and jurisdiction in Pennsylvania, is not waiving its
                    sovereign immunity or other Eleventh Amendment rights. This
                    provision shall survive termination of this Agreement.
                  </p>
                  <br />
                  <h6 class="md-subheading">Valuation Toolkit and Valuations</h6>
                  <p>
                    You should not use Valuations or other tools in the Bizminer
                    Valuation Toolkit in place of a valuation. Bizminer does not
                    suggest using Valuations or the Toolkit as the basis of any
                    specific business-related or other financial transaction. You
                    should not attempt to use a Valuations or other Valuation Toolkit
                    elements to secure a business or personal loan. Our data sources
                    may be incomplete or incorrect; nor <br />
                    <br />
                    have we physically researched or inspected many important details
                    necessary to the valuation of a specific enterprise. Neither the
                    Valuations nor other Valuation Toolkit tools consider the market
                    environment details nor the idiosyncrasies of a firm’s performance
                    that can influence the actual value or selling price. <br />
                    <br />
                    We encourage business buyers, sellers, owners and browsers to
                    enhance their understanding of the value of any enterprise before
                    making decisions or taking action. The Valuations and other
                    Valuation Toolkit elements are modeled informational tools, not
                    guides to action. For that we recommend obtaining an appraisal
                    from a business broker, a valuation from a certified valuation
                    professional, or both.
                  </p>
                  <br />
                  <h6 class="md-subheading">
                    Business Prospect Lists and Company Insight File Restrictions
                  </h6>
                  <p>
                    Business Prospect and Company Insight records and lists are not
                    included in the License base price, but may be purchased in
                    separate blocks. If purchased, you agree that business lists are
                    for internal use only; or for use by a single third party end user
                    client only if Licensee does not utilize the list in whole or part
                    for any other internal or external purpose. Otherwise,
                    distribution or sale of Prospect or Company Insight content in
                    whole or part is prohibited. Some data may not available for some
                    fields in every record; Lists and Company Insights may include
                    reasonable amounts of dated or erroneous information.
                  </p>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.$route.name != 'Register'" class="align-div-components">
      <md-checkbox v-model="acceptTermPolicy">I accept the Terms of Service &amp; Privacy Policy.
      </md-checkbox>
      <div class="action_wpr">
        <md-button class="md-primary md-round" :class="acceptTermPolicy ? '' : 'disabled'" @click="acceptTerms()">
          Next
          <md-icon>arrow_right_alt</md-icon>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  name: 'Terms',
  setup() { },
  data() {
    return {
      acceptTermPolicy: false,
    }

  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
      invoiceId: (state) =>state.invoicesModule.invoiceId,
    }),
  },
  methods: {
    acceptTerms() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

       axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/onboarding/tos',
          {},
          {
           params: {
              session_id: currentSession,
            },
          },
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }         
          this.addInvoiceToCart(this.invoiceId)
        });  
       
    },
     addInvoiceToCart: async function (invoiceId) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/cart/add_invoice',
          {},
          {
            params: {
              session_id: currentSession,
              invoice_id: invoiceId,
            },
          },
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          if (res.data.success) {
            this.$router.push({
              name: 'Cart',
            });
          }
        });
    },
  }
};
</script>

<style lang="scss">
.page-wrapper {
  .privacy-policy {
    h1 {
      font-size: 18px !important;
      color: #3c4858 !important;
      letter-spacing: 0.25px;
      font-weight: 300 !important;
      margin: 0;
    }
  }
}

.terms-body {
  padding: 20px 15px 100px 15px;

  .terms-body-title {

    h5,
    h6 {
      font-weight: 500;
      color: #3c4858;
    }

    h5 {
      font-size: 18px;
    }

    h6 {
      font-size: 17px;
    }

    span {
      font-size: 18px;
      color: #3b7ef1;
      font-weight: 500;
    }
  }

  p,
  ul li {
    font-size: 14px;
    line-height: 28px;
    margin: 0;
  }
}
</style>
